/* ============================================================
   The Good Monk — website audit improvements (behaviors)
   Quantity steppers, image zoom, hero slideshow, collection sort.
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Quantity +/- steppers ---------- */
    document.querySelectorAll('.qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      if (!input) return;
      stepper.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        var min = parseInt(input.min || '1', 10);
        var v = parseInt(input.value || min, 10);
        input.value = plus ? v + 1 : Math.max(min, v - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* ---------- Product image zoom (lightbox) ---------- */
    var mainImage = document.querySelector('[data-main-image]');
    if (mainImage) {
      var lb = document.createElement('div');
      lb.className = 'tgm-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-label', 'Zoomed product image');
      lb.innerHTML = '<button class="tgm-lightbox__close" aria-label="Close">&times;</button><img alt="">';
      document.body.appendChild(lb);
      var lbImg = lb.querySelector('img');
      var closeLb = function () {
        lb.classList.remove('is-open');
        document.body.style.overflow = '';
      };
      mainImage.addEventListener('click', function () {
        lbImg.src = mainImage.src;
        lbImg.alt = mainImage.alt || '';
        lb.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      lb.addEventListener('click', closeLb);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLb();
      });
    }

    /* ---------- Homepage hero slideshow ---------- */
    var hero = document.querySelector('[data-tgm-hero]');
    if (hero) {
      var slides = hero.querySelectorAll('.tgm-hero__slide');
      var dots = hero.querySelectorAll('.tgm-hero__dot');
      var current = 0;
      var timer = null;
      var show = function (n) {
        current = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      };
      var startAuto = function () {
        timer = setInterval(function () { show(current + 1); }, 5000);
      };
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          clearInterval(timer);
          show(i);
          startAuto();
        });
      });
      if (slides.length > 1) startAuto();
    }

    /* ---------- Collection sorting ---------- */
    var sortSelect = document.querySelector('[data-sort-products]');
    if (sortSelect) {
      var grid = document.querySelector('.product-grid');
      var getName = function (card) {
        var t = card.querySelector('.product-card__title, h3');
        return t ? t.textContent.trim() : '';
      };
      var getPrice = function (card) {
        var p = card.querySelector('.product-card__price, [class*="price"]');
        return p ? (parseFloat(p.textContent.replace(/[^0-9.]/g, '')) || 0) : 0;
      };
      sortSelect.addEventListener('change', function () {
        if (!grid) return;
        var mode = sortSelect.value;
        var cards = Array.prototype.slice.call(grid.children);
        cards.sort(function (a, b) {
          switch (mode) {
            case 'name-asc': return getName(a).localeCompare(getName(b));
            case 'name-desc': return getName(b).localeCompare(getName(a));
            case 'price-asc': return getPrice(a) - getPrice(b);
            case 'price-desc': return getPrice(b) - getPrice(a);
            default: return 0;
          }
        });
        cards.forEach(function (c) { grid.appendChild(c); });
      });
    }
  });
})();

/* ============================================================
   Product page redesign behaviors (Figma build)
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {

    /* PayJustNow instalment amount — 1/3 of the current price */
    var priceEl = document.querySelector('[data-price]');
    var pjnAmount = document.querySelector('[data-pjn-amount]');
    if (priceEl && pjnAmount) {
      var updatePjn = function () {
        var v = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
        if (v > 0) {
          var third = Math.round((v / 3) * 100) / 100;
          pjnAmount.textContent = 'R ' + (third % 1 === 0 ? third : third.toFixed(2));
        }
      };
      updatePjn();
      new MutationObserver(updatePjn).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* Subscribe + PayJustNow info popups (popup must be the button's next sibling) */
    document.querySelectorAll('[data-buy-info], [data-pjn-info]').forEach(function (btn) {
      var pop = btn.nextElementSibling;
      if (!pop) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isOpen = !pop.hasAttribute('hidden');
        if (isOpen) { pop.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
        else { pop.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.buy-info__pop:not([hidden]), .pjn__pop:not([hidden])').forEach(function (pop) {
        if (!pop.parentElement.contains(e.target)) pop.setAttribute('hidden', '');
      });
    });

    /* ---------- Wishlist (localStorage + drawer, until a wishlist app is installed) ---------- */
    var WL_KEY = 'tgm-wishlist';
    var wlRead = function () { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } };
    var wlWrite = function (l) { try { localStorage.setItem(WL_KEY, JSON.stringify(l)); } catch (e) {} };
    var wlIndex = function (l, path) { for (var i = 0; i < l.length; i++) { if (l[i] && l[i].path === path) return i; } return -1; };

    var wlDrawer = document.querySelector('[data-wishlist-drawer]');
    var wishBtn = document.querySelector('[data-wishlist]');
    var productPath = location.pathname;

    var wlSyncBadge = function () {
      var n = wlRead().length;
      document.querySelectorAll('[data-header-wishlist]').forEach(function (a) {
        var b = a.querySelector('.wishlist-count');
        if (!b) { b = document.createElement('span'); b.className = 'wishlist-count'; a.appendChild(b); }
        b.textContent = n;
        if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
      });
    };
    var wlSyncBtn = function () {
      if (!wishBtn) return;
      var active = wlIndex(wlRead(), productPath) > -1;
      wishBtn.classList.toggle('is-active', active);
      wishBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
    };
    var wlRenderDrawer = function () {
      if (!wlDrawer) return;
      var body = wlDrawer.querySelector('[data-wishlist-body]');
      if (!body) return;
      var l = wlRead();
      if (!l.length) { body.innerHTML = '<p class="wishlist-drawer__empty">Your wishlist is empty.<br>Tap the heart on any product to save it here.</p>'; return; }
      body.innerHTML = l.map(function (it) {
        var key = encodeURIComponent(it.path);
        return '<div class="wishlist-item">' +
          '<a href="' + it.path + '" class="wishlist-item__media">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="wishlist-item__info"><a href="' + it.path + '" class="wishlist-item__title">' + (it.title || 'Product') + '</a>' +
          (it.price ? '<span class="wishlist-item__price">' + it.price + '</span>' : '') +
          '<div class="wishlist-item__actions"><a href="' + it.path + '" class="btn btn--outline">View Product</a>' +
          '<button type="button" class="wishlist-item__remove" data-wishlist-remove="' + key + '" aria-label="Remove">Remove</button></div></div></div>';
      }).join('');
    };
    var wlOpen = function (e) { if (e) e.preventDefault(); if (!wlDrawer) return; wlRenderDrawer(); wlDrawer.classList.add('is-open'); wlDrawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
    var wlClose = function () { if (!wlDrawer) return; wlDrawer.classList.remove('is-open'); wlDrawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

    if (wishBtn) {
      wlSyncBtn();
      wishBtn.addEventListener('click', function () {
        var l = wlRead(), i = wlIndex(l, productPath);
        if (i > -1) { l.splice(i, 1); }
        else {
          var titleEl = document.querySelector('.product__title');
          var priceEl = document.querySelector('[data-price]');
          var imgEl = document.querySelector('[data-main-image]') || document.querySelector('.product__main img');
          l.push({
            path: productPath,
            title: titleEl ? titleEl.textContent.trim() : document.title,
            price: priceEl ? priceEl.textContent.trim() : '',
            image: imgEl ? imgEl.src : ''
          });
        }
        wlWrite(l); wlSyncBtn(); wlSyncBadge(); wlRenderDrawer();
      });
    }

    document.querySelectorAll('[data-header-wishlist]').forEach(function (a) { a.addEventListener('click', wlOpen); });
    if (wlDrawer) {
      wlDrawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-wishlist-close]')) { wlClose(); return; }
        var rm = e.target.closest('[data-wishlist-remove]');
        if (rm) {
          var p = decodeURIComponent(rm.getAttribute('data-wishlist-remove'));
          var l = wlRead(), i = wlIndex(l, p);
          if (i > -1) { l.splice(i, 1); wlWrite(l); }
          wlRenderDrawer(); wlSyncBadge(); wlSyncBtn();
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') wlClose(); });
    }
    wlSyncBadge();


    /* Reviews "See more" (mobile reveals the rest) */
    var seeMore = document.querySelector('[data-see-more]');
    if (seeMore) {
      seeMore.addEventListener('click', function () {
        seeMore.closest('.tgm-social').classList.add('expanded');
        seeMore.style.display = 'none';
      });
    }
  });
})();

/* ============================================================
   Transparent → solid sticky nav (homepage hero overlay)
   ============================================================ */
(function () {
  'use strict';
  var header = document.querySelector('.site-header');
  if (!header) return;

  // Expose the header's real height so the hero can sit behind it (CSS var).
  var setHeaderH = function () {
    document.documentElement.style.setProperty('--tgm-header-h', header.offsetHeight + 'px');
  };
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  // Only the homepage overlays the hero; elsewhere the header is always solid.
  var isHome = document.body.classList.contains('template-index');
  if (!isHome) { header.classList.add('is-scrolled'); return; }

  var onScroll = function () {
    if (window.scrollY > 30) header.classList.add('is-scrolled');
    else header.classList.remove('is-scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ============================================================
   Robust autoplay for background videos.
   Markup already has autoplay/muted/playsinline; this adds a
   belt-and-suspenders play() plus a first-interaction fallback
   for cases where the browser/OS defers autoplay (e.g. data
   saver). Note: iOS Low Power Mode blocks autoplay entirely and
   cannot be overridden — first tap/scroll will start it.
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var vids = document.querySelectorAll('video[autoplay]');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', '');
      v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    });
    var playAll = function () {
      vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    };
    playAll();
    ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, playAll, { passive: true, once: true });
    });
  });
})();
